export const SET_NOTIFICATIONS = 'SET_NOTIFICATIONS'
export const ADD_NOTIFICATION = 'ADD_NOTIFICATION'
